import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../assets/css/Hero.css";

import hero from "../assets/home-page-imgs/g-hero.jpg";
import banner from "../assets/Gallery/arambh-banner.jpg"; // 👉 your full screen banner image

import comingsoonbanner from '../assets/Gallery/aarambh_coming_soon_banner.jpeg';

import { Link } from "react-router-dom";

const SamriddhiGurukulHero = () => {
    /* ================= EXISTING LOGIC (UNCHANGED) ================= */

    const cardRefs = useRef([]);
    const statsRef = useRef(null);
    const [hasCounted, setHasCounted] = useState(false);

    const stats = [
        { value: 10, label: "Years of Trust" },
        { value: 5000, label: "Students Trained" },
        { value: 100, label: "Certification Support" },
    ];

    const [counterValues, setCounterValues] = useState(stats.map(() => 0));

    const animateCounters = () => {
        const duration = 1500;
        const frameRate = 30;

        stats.forEach((stat, index) => {
            let current = 0;
            const increment = stat.value / (duration / frameRate);

            const interval = setInterval(() => {
                current += increment;
                if (current >= stat.value) {
                    current = stat.value;
                    clearInterval(interval);
                }
                setCounterValues((prev) => {
                    const updated = [...prev];
                    updated[index] = Math.floor(current);
                    return updated;
                });
            }, frameRate);
        });
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !hasCounted) {
                        setHasCounted(true);
                        animateCounters();
                        entry.target.classList.add("hero-fade-in");
                    }
                });
            },
            { threshold: 0.4 }
        );

        if (statsRef.current) observer.observe(statsRef.current);
    }, [hasCounted]);

    useEffect(() => {
        cardRefs.current.forEach((card, index) => {
            setTimeout(() => {
                if (card) card.classList.add("hero-card-animate");
            }, index * 350);
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("hero-fade-in");
                    }
                });
            },
            { threshold: 0.2 }
        );

        cardRefs.current.forEach((card) => observer.observe(card));
        if (statsRef.current) observer.observe(statsRef.current);
    }, []);

    /* ================= CAROUSEL ================= */

    return (
        <div className="hero-carousel-wrapper">
            <Swiper
                modules={[Navigation, Pagination]}
                slidesPerView={1}
                loop={true}
                speed={900}
                navigation
                pagination={{ clickable: true }}
                grabCursor={true}
                resistanceRatio={0.85}
                threshold={10}
                className="hero-swiper"
            >


                {/* ========== SLIDE 2 : FULL SCREEN BANNER ========== */}
                <SwiperSlide>
                    {/* <div className="hero-banner-slide">
                        <img
                            src={banner}
                            alt="Banner"
                            className="hero-banner-img"
                            draggable="false"
                        />

                        <div className="sg-event-urgency">
                            ⚠️ Limited Seats Available
                        </div>
                        <Link to="/Webinars"><button className="regi">Register Now</button></Link>

                        <p className="sg-event-hero-subtitle">
                            1 Day • Live Event • Pune <br />
                            Learning • Networking • Certification
                            <br />
                            <br />
                            Meet us at AARAMBH to learn, grow, and build your future in real estate.
                        </p>



                    </div> */}
                    <div className="hero-banner-slide">
                        <img
                            src={comingsoonbanner}
                            alt="Banner"
                            className="hero-banner-img"
                            draggable="false"
                        />

                        <div className="sg-event-urgency">
                            ⚠️ Limited Seats Available
                        </div>
                        <Link to="/Webinars"><button className="regi">Register Now</button></Link>

                        <p className="sg-event-hero-subtitle">
                            1 Day • Live Event • Pune <br />
                            Learning • Networking • Certification
                            <br />
                            <br />
                            Meet us at AARAMBH to learn, grow, and build your future in real estate.
                        </p>



                    </div>
                </SwiperSlide>


                {/* ========== SLIDE 1 : YOUR EXISTING HERO (UNCHANGED) ========== */}
                <SwiperSlide>
                    <div className="hero-container">
                        <div className="hero-left">
                            <h1 className="hero-title">
                                A Bright Future Begins Here,<br />
                                and We Are Ready to Guide You
                            </h1>

                            <p className="hero-subtitle">
                                Samriddhi Gurukul empowers with structured training,
                                real-world expertise, and a future-ready approach to success.
                            </p>

                            <div className="hero-buttons">
                                <button className="hero-btn-primary">Get Started</button>
                                <button className="hero-btn-secondary">Learn More →</button>
                            </div>

                            {/* <div className="hero-cards-wrapper">
                                {[
                                    {
                                        id: "01",
                                        title: "Career-Oriented Courses",
                                        desc: "Structured learning modules crafted for real success.",
                                    },
                                    {
                                        id: "02",
                                        title: "Expert Faculty",
                                        desc: "Industry professionals guiding every step of the journey.",
                                    },
                                    {
                                        id: "03",
                                        title: "Gurukul Certification",
                                        desc: "A trusted certification with strong future value.",
                                    },
                                ].map((card, index) => (
                                    <div
                                        key={index}
                                        className="hero-card"
                                        ref={(el) => (cardRefs.current[index] = el)}
                                    >
                                        <p className="hero-card-id">{card.id}</p>
                                        <h4 className="hero-card-title">{card.title}</h4>
                                        <p className="hero-card-desc">{card.desc}</p>
                                    </div>
                                ))}
                            </div> */}
                        </div>

                        <div className="hero-right">
                            {/* <img src={hero} alt="hero" className="hero-founder-img" /> */}

                            {/* <div className="hero-stats" ref={statsRef}>
                                {stats.map((stat, index) => (
                                    <div className="hero-stat" key={index}>
                                        <h3>
                                            {counterValues[index]}
                                            {stat.value !== 1 ? "+" : ""}
                                        </h3>
                                        <p>{stat.label}</p>
                                    </div>
                                ))}
                            </div> */}
                        </div>
                    </div>
                </SwiperSlide>


            </Swiper>
        </div>
    );
};

export default SamriddhiGurukulHero;
